import { useMemo, useState } from "react";
import { IFood } from "../models/IFood";
import { IFoodCategory } from "../models/IFoodCategory";
import { S3_IMAGE_BASE_URL } from "../config/restaurantConfig";

interface Props {
  foods: IFood[];
  categories: IFoodCategory[];
}

export default function Menu({ foods, categories }: Props) {
  const categoriesWithFood = useMemo(
    () => categories.filter((c) => foods.some((f) => f.foodCategoryId === c.id)),
    [categories, foods]
  );
  const [activeCategoryId, setActiveCategoryId] = useState<string | undefined>(undefined);
  const currentCategoryId = activeCategoryId ?? categoriesWithFood[0]?.id;

  const visibleFoods = foods.filter((f) => f.foodCategoryId === currentCategoryId);

  return (
    <section id="menu" className="rr-section">
      <div className="rr-section-title">
        <span>Lezzetlerimiz</span>
        <h2>Menü</h2>
      </div>

      {categoriesWithFood.length === 0 ? (
        <p style={{ textAlign: "center", color: "#9a9488" }}>Menü yakında eklenecek.</p>
      ) : (
        <>
          <div className="rr-menu-tabs">
            {categoriesWithFood.map((c) => (
              <button
                key={c.id}
                type="button"
                className={`rr-menu-tab${currentCategoryId === c.id ? " active" : ""}`}
                onClick={() => setActiveCategoryId(c.id)}
              >
                {c.foodCategoryNameTr}
              </button>
            ))}
          </div>

          <div className="rr-menu-grid">
            {visibleFoods.map((food) => (
              <div key={food.id} className="rr-food-card">
                {food.foodImagePath && (
                  <img className="rr-food-img" src={S3_IMAGE_BASE_URL + food.foodImagePath} alt={food.foodNameTr} />
                )}
                <div className="rr-food-body">
                  <div className="rr-food-top">
                    <span className="rr-food-name">{food.foodNameTr}</span>
                    <span className="rr-food-price">{food.foodPriceText || food.foodPrice}</span>
                  </div>
                  {food.foodDescriptionTr && <p className="rr-food-desc">{food.foodDescriptionTr}</p>}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </section>
  );
}
